import { render, staticRenderFns } from "./recallNoticeHistory.vue?vue&type=template&id=1161c75f&scoped=true"
import script from "./recallNoticeHistory.vue?vue&type=script&lang=js"
export * from "./recallNoticeHistory.vue?vue&type=script&lang=js"
import style0 from "./recallNoticeHistory.vue?vue&type=style&index=0&id=1161c75f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1161c75f",
  null
  
)

export default component.exports